import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";

const Landing = dynamic(() => import("@/components/landing"));

const Home = ({ pageData = {} }) => {
  return <Landing pageData={pageData} />;
};

export async function getStaticProps({ preview, locale }) {
  const {
    items,
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
  } = await getPageShellDataSafely({
    slug: `/`,
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: true,
    locale,
  });
  const pageData = items?.[0]?.fields;
  if (!pageData) {
    return {
      notFound: true,
      revalidate: 10,
    };
  }

  return {
    props: {
      pageData,
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
    },
    revalidate: 60, // Revalidate every 60 seconds
  };
}

Home.propTypes = {
  pageData: PropTypes.object,
};

export default Home;
